import axios from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IGetFollowedExportationsPayload,
} from '@EditorModules/Exportation/types'

export function getFollowedExportations(payload: IGetFollowedExportationsPayload) {
  return axios.post('/api/v1/exportations/get_by_ids', convertToSnakeCase(payload))
}
